import Team from 'iam/models/Team'
import { computed, makeObservable } from 'mobx'
import Workspace from 'iam/models/Workspace'

export class TeamItemViewModel {
  constructor(
    public team: Team,
    public workspace: Workspace,
  ) {
    makeObservable(this)
  }

  @computed
  get teamOwner() {
    return this.team.owner
  }

  /**
   * Called when the view model becomes relevant.
   */
  activate() {
    //
  }

  /**
   * Called when the view model is no longer actively used.
   */
  deactivate() {
    //
  }
}
